module.exports = __webpack_public_path__ + "/images/1VCDom_.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/supermanVid.mp4
// module id = 247
// module chunks = 0